'use strict';

import angular from 'angular';

export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('main.forum', {
        url: '/forum',
        templateUrl: 'app/forum/forum.html',
        controller: 'ForumController'
      });
  }]);
